import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { css } from "twin.macro";
import MainLayout from "../../MainLayout/MainLayout";
import { EmptyData, PageTitleNavigation, SplitPane, TimelineComp } from "../..";
import { useFetchTimelineDetail } from "../../../redux/api/Timeline";
import { TimelineContainer, Wrapper } from "./component";
import { isEmpty } from "../../../lib/helpers/helpers";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Typography } from "antd";
import dayjs from "dayjs";
import TimelineCommentDetails from "../TimelineCommentDetails/TimelineCommentDetails";
import Auth from "../../../lib/middleware/auth";

export const active = (props) => css`
	${tw`font-bold uppercase shadow rounded-2xl min-w-min text-appTextDark inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(text-appTextDark  bg-gray-200 border-none)`}
	font-family: Poppins;
	background-color: rgba(151, 151, 189, 0.2);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;
export const inactive = (props) => css`
	${tw`font-medium uppercase shadow-sm rounded-2xl min-w-min text-appTextFaded inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(border-none  bg-gray-200)`}
	font-family: Poppins;
	background-color: rgba(166, 166, 175, 0.082);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;

const TimelinePostDetail = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const location = useLocation();
	const routeData = location.state;
	const [timeline, setTimeline] = useState({});
	const userData = Auth.getUser();
	useEffect(() => {
		if (isEmpty(routeData)) {
			return;
		}
		setTimeline(routeData.timeline);
	}, [routeData]);

	const {
		data: timelineDt,
		isLoading,
		refetch,
	} = useFetchTimelineDetail({
		weddingId: timeline?.weddingId,
		postId: timeline?.id,
		comments_paginate: 15,
	});

	useEffect(() => {
		if (isEmpty(timelineDt)) {
			return;
		}
		const { hasError } = timelineDt;
		if (hasError) {
			return;
		}
		setTimeline(timelineDt.data);
	}, [timelineDt]);
	console.log(timeline, userData);

	return (
		<MainLayout tw="relative">
			<Wrapper>
				<PageTitleNavigation title={"Post Details"} showBack />
				<SplitPane
					wrapDirection={"column"}
					mainHeightAdjust={isMobile ? "10rem" : "11rem"}
					rightHeightAdjust={isMobile ? "0rem" : "12rem"}
					leftHeightAdjust={isMobile ? "0rem" : "10rem"}
					left={
						<div tw="w-full h-auto">
							<Typography.Title
								level={4}
								tw="text-appGray-50! text-sm!">
								{" "}
								{dayjs(timeline?.createdAt).format(
									"dddd, D MMMM YYYY"
								)}
							</Typography.Title>
							<div>
								<Typography.Title
									level={4}
									tw="m-0! opacity-80">
									{timeline?.authorId === userData?.id
										? "You"
										: `${timeline?.user?.firstname} ${timeline?.user?.lastname}`}
								</Typography.Title>
								<Typography.Text tw="opacity-70">
									{timeline?.authorId === timeline?.wedding?.createdBy
										? "Couple"
										: "Guest"}
								</Typography.Text>
							</div>
							<TimelineContainer tw="mt-2 overflow-x-hidden overflow-y-auto gap-4">
								{isEmpty(timeline) ? (
									<EmptyData />
								) : (
									<TimelineComp
										likes={timeline?.likes_count}
										comments={timeline?.comments_count}
										imageBg={
											timeline.wedding
												?.story_cover_image_url
										}
										timelineData={timeline}
										loading={isLoading}
										large
									/>
								)}
							</TimelineContainer>
							<h4 tw="mt-2">
								<span tw="font-bold mr-2 text-base">
									{timeline?.user?.firstname}
								</span>
								{timeline?.post_text}
							</h4>
						</div>
					}
					right={
						<div tw="w-full h-full">
							<TimelineCommentDetails
								timeline={timeline}
								focus={routeData?.focus}
								refetch={() => refetch()}
							/>
						</div>
					}
				/>
			</Wrapper>
		</MainLayout>
	);
};

export default TimelinePostDetail;
